<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/projectList' }">網頁監控</el-breadcrumb-item>
                <el-breadcrumb-item>專案詳情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="title">{{projectInfo.name}}</div>
            <el-tabs v-model="activeName"
                     type="card"
                     @tab-click="changeTabs">
                <el-tab-pane label="Grafana監控"
                             name="Grafana監控">
                    <template v-if="chartInfo.length>0">
                        <el-row v-for=" (chart,index) in chartInfo"
                                :key="index">
                            <el-col>
                                <div class="chart-title">{{chart.name}}</div>
                                <iframe width="100%"
                                        height="500px"
                                        :src="chart.url+'&project_id='+projectId+'&token='+token"
                                        title="W3Schools Free Online Web Tutorials"></iframe>
                            </el-col>
                        </el-row>
                    </template>
                    <template v-else>
                        <div class="no-result">暫無圖表</div>
                    </template>

                </el-tab-pane>
                <el-tab-pane label="專案網域列表"
                             name="專案網域列表">
                    <TableTemplate :colums="colums"
                                   v-loading="listLoading"
                                   :data="tableData"
                                   :paginationShow="true"
                                   :pageIndex="pageIndex"
                                   :pageCount="pageCount"
                                   @change-page="changePage">
                        <!-- 自動續費 -->
                        <template v-slot:is_renew_auto="data">
                            <div v-if="data.data.is_renew_auto=='Y'">是</div>
                            <div v-else>否</div>
                        </template>
                        <!-- DNS指向 -->
                        <template v-slot:nameservers="data">
                            <el-tooltip class="item"
                                        effect="dark"
                                        placement="top">
                                <template #content> <template v-for="(server,idx) in data.data.nameservers"
                                              :key="idx">
                                        {{server}}
                                        <br>
                                    </template>
                                </template>
                                <div class="tool-tip-text"
                                     v-html="nameSeverChange(data.data.nameservers)"></div>
                            </el-tooltip>
                        </template>
                        <!-- 分享給-->
                        <template v-slot:share_list="data">
                            <div :key="index"
                                 v-for="(share,index) in data.data.share_list">
                                {{share.share_id}}
                            </div>
                        </template>
                    </TableTemplate>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import TableTemplate from '../../../components/TableTemplate.vue'
import { showProjectList, projectDomainList } from '../../../api/index'
import { getCookie } from '../../../utils/cookie'
export default {
    components: {
        TableTemplate,
    },
    data() {
        return {
            projectId: '',
            token: getCookie('__tk').replace('Bearer', '').trim(),
            activeName: 'Grafana監控',
            projectInfo: [],
            chartInfo: [],
            colums: [
                {
                    name: '網域名稱',
                    prop: 'domain',
                },
                {
                    name: '來源註記',
                    prop: 'remark',
                },
                {
                    name: '建立時間',
                    prop: 'domain_created_at',
                },
                {
                    name: '到期時間',
                    prop: 'domain_expires_at',
                },
                {
                    name: '可續約時間',
                    prop: 'domain_renew_deadline',
                },
                {
                    name: '自動續費',
                    type: 'slot',
                    attribute: { slotName: 'is_renew_auto' },
                },
                {
                    name: '域名狀態',
                    prop: 'status',
                },
                {
                    name: '最後更新時間',
                    prop: 'updated_at',
                },
                {
                    name: 'DNS指向',
                    type: 'slot',
                    attribute: { slotName: 'nameservers' },
                },
                {
                    name: '分享給',
                    type: 'slot',
                    attribute: { slotName: 'share_list' },
                },
            ],
            tableData: [],
            pageIndex: 1,
            pageCount: 0,
            listLoading: false,
        }
    },
    mounted() {
        if (typeof this.$route.query.projectId == 'undefined') {
            this.$router.push({ path: 'projectList' })
        } else {
            this.projectId = this.$route.query.projectId
            this.getData()
        }
    },
    methods: {
        getData() {
            showProjectList({
                id: this.projectId,
            })
                .then((res) => {
                    if (res.code == 300) {
                        this.projectInfo = res.data.project
                        this.chartInfo = res.data.charts
                    }
                    if (res.code == 500) {
                        this.$message.error(res.message)
                    }
                    this.listLoading = false
                })
                .catch((err) => {
                    console.log(err)
                    this.listLoading = false
                })
        },
        getProjectDomain() {
            this.listLoading = true
            projectDomainList({
                project_id: this.projectId,
                page: this.pageIndex,
            })
                .then((res) => {
                    if (res.code == 300) {
                        this.tableData = res.data.data_list
                        this.pageCount = res.data.total_page
                    }
                    if (res.code == 500) {
                        this.$message.error(res.message)
                    }
                    this.listLoading = false
                })
                .catch((err) => {
                    console.log(err)
                    this.listLoading = false
                })
        },
        changeTabs(tab) {
            if (tab.props.label === '專案網域列表') {
                this.getProjectDomain()
            }
        },
        changePage(val) {
            this.pageIndex = val
            this.getData()
        },
        //dns指向更改
        nameSeverChange(array) {
            let a = array || []
            return a.join('<br>')
        },
    },
}
</script>

<style lang="scss" scoped>
.title {
    text-align: center;
    font-size: 22px;
    padding-bottom: 15px;
    font-weight: bold;
}
.add-btn {
    padding-bottom: 15px;
}
.chart-title {
    padding: 10px 0px;
    font-size: 18px;
}
.no-result {
    text-align: center;
    color: #999;
}
</style>